<template>
  <div :class="fieldClass">
    <label v-if="hasLabel">{{ label }}</label>
    <ckeditor
      :editor="editor"
      :config="getEditorConfig"
      tag-name="textarea"
      v-model="content"
      :name="fieldName"
      :id="id"
    />
  </div>
</template>

<script>
import CKEditor from "@ckeditor/ckeditor5-vue2";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic/build/ckeditor";

ClassicEditor.defaultConfig = {
  toolbar: {
    items: [
      "heading",
      "|",
      "bold",
      "italic",
      "link",
      "|",
      "bulletedList",
      "numberedList",
      "|",
      "insertTable",
      "|",
      "undo",
      "redo",
    ],
  },
  image: {
    toolbar: [],
  },
  table: {
    contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
  },
  language: "en",
};

export default {
  name: "WysiwygEditorField",
  data() {
    return {
      editor: ClassicEditor,
      internalContent: "",
    };
  },
  components: {
    ckeditor: CKEditor.component,
  },
  props: {
    id: { type: String, default: null },
    label: { type: String, default: null },
    fieldClass: { type: String, default: null },
    fieldName: { type: String, default: null },
    useVuex: { type: Boolean, default: false },
    getterMethod: { type: String, default: null },
    setterMethod: { type: String, default: null },
    value: { type: String, default: "" },
    placeholders: { type: Array, default: () => [] },
  },
  computed: {
    getEditorConfig: function () {
      return {
        placeholderProps: {
          types: this.placeholders,
        },
        placeholderBrackets: {
          open: "",
          close: "",
        },
      };
    },
    content: {
      get() {
        if (this.useVuex && this.getterMethod) {
          return this.$store.getters[this.getterMethod];
        }
        return this.internalContent;
      },
      set(value) {
        this.internalContent = value;
        if (this.useVuex && this.setterMethod) {
          this.$store.commit(this.setterMethod, value);
        } else {
          this.$emit("update-value", value);
        }
      },
    },
    hasLabel: function () {
      return this.label !== "";
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue, oldValue) {
        this.content = newValue;
      },
    },
  },
  created() {
    if (this.placeholders.length > 0) {
      if (ClassicEditor.defaultConfig.toolbar.items.includes("placeholder")) {
        const index = ClassicEditor.defaultConfig.toolbar.items.findIndex(
          (item) => item === "placeholder",
        );
        ClassicEditor.defaultConfig.toolbar.items.splice(index, 1);
      }

      ClassicEditor.defaultConfig.toolbar.items.push("placeholder");
    }
  },
};
</script>

<style scoped></style>
